import { COMPONENT_TYPES } from '../../../constants';
import BenefitSummaryComponent from './BenefitSummary.component';
import BenefitSummaryEditor from './BenefitSummary.editor';
import BenefitSummaryProperties from './BenefitSummary.properties';
import { registerComponent } from '../registry';

// 컴포넌트 타입 상수
export const COMPONENT_TYPE = 'BENEFIT_SUMMARY';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.BENEFIT_SUMMARY,
  component: BenefitSummaryComponent,
  editorComponent: BenefitSummaryEditor,
  properties: BenefitSummaryProperties,
  defaultProps: {
    style: {
      width: '100%',
      margin: '0 auto',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 6px rgba(0, 0, 0, 0.05)',
      padding: '20px',
      fontFamily: 'inherit'
    },
    componentProps: {
      title: '최근 1개월 요약',
      description: '최근 한 달간의 혜택 내역을 확인하세요',
      emptyText: '데이터가 없습니다'
    }
  },
  category: 'finance', // 컴포넌트 카테고리
  icon: '💰', // 대표 아이콘
  name: '혜택 요약' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as BenefitSummaryComponent } from './BenefitSummary.component';
export { default as BenefitSummaryEditor } from './BenefitSummary.editor';
export { default as BenefitSummaryProperties } from './BenefitSummary.properties';
export * from './BenefitSummary.types'; 